import { DefaultButton, FocusTrapZone, IconButton, Layer, mergeStyleSets, Overlay, Popup } from "@fluentui/react";
import i18next from "../../i18n/i18n";

interface Props {
    show: boolean;
    errorMessage: string;
    onConfirm: () => void;
}

export const TokenLimitErrorDialog = ({ show, errorMessage, onConfirm }: Props) => {
    const popupStyles = mergeStyleSets({
        root: {
            background: "rgba(0, 0, 0, 0.2)",
            bottom: "0",
            left: "0",
            position: "fixed",
            right: "0",
            top: "0"
        },
        content: {
            background: "white",
            left: "50%",
            maxWidth: "1000px",
            padding: "0 0em 2em",
            position: "absolute",
            top: "50%",
            transform: "translate(-50%, -50%)"
        }
    });

    if (!show) {
        return null;
    }

    return (
        <Layer>
            <Popup className={popupStyles.root} role="dialog" aria-modal="true">
                <Overlay />
                <FocusTrapZone>
                    <div role="document" className={popupStyles.content}>
                        <div>
                            <span style={{ padding: "5px", fontSize: "16px", fontWeight: "bold", display: "block", marginTop: "10px" }}>
                                {i18next.t("chat.tokenLimitErrorTitle")}
                            </span>
                            <span style={{ padding: "5px", fontSize: "14px", display: "block", marginTop: "15px", whiteSpace: "pre-wrap" }}>
                                {errorMessage}
                            </span>
                            <span style={{ padding: "5px", fontSize: "14px", display: "block", marginTop: "15px", fontStyle: "italic" }}>
                                {i18next.t("chat.tokenLimitErrorMessage")}
                            </span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                            <DefaultButton
                                autoFocus
                                style={{ borderRadius: "1.5rem", padding: "5px 20px", backgroundColor: "#0078d4", color: "white" }}
                                onClick={onConfirm}
                            >
                                {i18next.t("chat.startNewChat")}
                            </DefaultButton>
                        </div>
                    </div>
                </FocusTrapZone>
            </Popup>
        </Layer>
    );
};
